import React from "react";

const comparisonData = [
  ["Speed & Uptime", "Can be slow; downtime risk with single machine", "Lightning-fast; offline-first with auto-sync"],
  ["Multi-Outlet", "Manual consolidation; error-prone", "Centralized pricing, stock & approvals"],
  ["Inventory", "Basic counts; limited alerts", "Real-time stock, low-stock alerts, auto-reorder"],
  ["Reporting", "End-of-day exports", "Live dashboards, KPIs, mobile owner app"],
  ["Menu/Catalog", "Rigid; tough to manage combos", "Variants, modifiers, bundles, timed pricing"],
  ["Compliance", "Manual formats", "VAT/GST, e-invoicing, multi-currency/localization"],
  ["Integrations", "Limited connectors", "Armada Online Ordering + 3rd-party platforms"],
  ["Setup & Support", "Slow onboarding", "Rapid migration, training & 24×7 support"],
];

const Comparison = () => (
  <section id="comparison" className="py-16 bg-white">
    <div className="max-w-7xl mx-auto px-4">
      <h2 className="text-2xl md:text-3xl font-extrabold">Traditional vs. Armada POS</h2>
      <p className="mt-2 text-slate-600 max-w-3xl">
        Cut complexity, boost speed, and stay connected everywhere.
      </p>

      <div className="mt-8 overflow-x-auto">
        <table className="min-w-full border-collapse shadow-lg rounded-xl overflow-hidden">
          <thead className="bg-slate-100 text-slate-700">
            <tr>
              <th className="text-left px-4 py-3 font-semibold">Capability</th>
              <th className="text-left px-4 py-3 font-semibold">Traditional POS</th>
              <th className="text-left px-4 py-3 font-semibold">Armada POS</th>
            </tr>
          </thead>
          <tbody className="divide-y">
            {comparisonData.map((row, idx) => (
              <tr key={idx} className="even:bg-white odd:bg-slate-50">
                <td className="px-4 py-3 font-medium">{row[0]}</td>
                <td className="px-4 py-3 text-slate-600">{row[1]}</td>
                <td className="px-4 py-3 text-slate-900 font-medium">{row[2]}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="mt-8">
        <a
          href="#signup"
          className="inline-flex items-center rounded-lg px-5 py-3 bg-blue-600 text-white font-semibold hover:bg-blue-700 transition"
        >
          Start Free Trial
        </a>
      </div>
    </div>
  </section>
);

export default Comparison;
